"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regFieldsOrderDefault = exports.getCoords = void 0;
const immutable_1 = require("immutable");
const getCoords = (elem) => {
    const box = elem.getBoundingClientRect();
    return {
        top: box.top + window.scrollY,
        left: box.left + window.scrollX,
    };
};
exports.getCoords = getCoords;
exports.regFieldsOrderDefault = (0, immutable_1.List)([
    'accountColor',
    'select',
    'account',
    'postedOn',
    'payee',
    'category',
    'split',
    'expense',
    'income',
    'amount',
    'save',
    'close',
    'menu',
]);
